<template>
  <el-dialog custom-class="dialog-modal-permission" :model-value="flagVisible" width="770px" :before-close="handleClose">
    <div class="modal-permission">
      <div class="modal-p-content text-that-needs-wrapping">
        <div class="modal-p-title">
          <span>Frequency Graphs give hearing superpowers!</span>
        </div>
        <div class="modal-p-desc">
          <p>There’s nothing like a powerful visual to help your customers instantly differentiate one product from another. Now, whether your website visitor is a novice or an expert, <b>Frequency Graphs</b> help tell the full story of the sound.</p>
          <p>If <b>Frequency Graphs</b> are not part of your subscription, contact <a href="mailto:sales@audiotestkitchen.com">sales@audiotestkitchen.com</a> to upgrade.</p>
        </div>
      </div>
      <div class="modal-p-img">
        <img src="@/assets/images/permissions/fea_freq.png" alt="" />
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    flagVisible: Boolean
  },
  emits: ['closeModal'],
  data: function () {
    return {
    }
  },
  created: function () {
  },
  watch: {
  },
  methods: {
    handleClose: function () {
      this.$emit('closeModal')
    }
  }
}
</script>
